(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery-manual"] && !Shopify.designMode) return;
  try {
    
(function(){
  var vids=[].slice.call(document.querySelectorAll('.pg-bgvideo[data-src]'));
  if(!vids.length)return;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData=navigator.connection&&navigator.connection.saveData;
  if(reduce||saveData)return;
  function play(v){
    if(!v.src){v.src=v.getAttribute('data-src');v.addEventListener('playing',function(){v.classList.add('is-playing');});}
    var p=v.play();if(p&&p.catch)p.catch(function(){});
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)play(e.target);else if(!e.target.paused)e.target.pause();});},{rootMargin:'200px'});
    vids.forEach(function(v){io.observe(v);});
  }else{vids.forEach(play);}
})();

  } catch(e) { console.error(e); }
})();
})();
